module.exports = __webpack_public_path__ + "img/image24.422ebf40.png";